<template>
  <div class="columns">
    <div class="column is-3">
      <b-field label="受注日" expanded>
        <b-datepicker
          @input="changeBiddingDate"
          v-model="biddingDate"
          icon="calendar-day"
          trap-focus
          v-bind:class="{ borderRed: isValidate }"
        >
        </b-datepicker>
      </b-field>
    </div>
    <div class="column">
      <b-field label="オークション会場" expanded>
        <b-autocomplete
          :data="filteredAuctionSiteList"
          field="E_AuctionAreaSatellite.value"
          v-model="auctionVendorInput"
          @select="setAuctionVendor"
          open-on-focus
          clearable
        ></b-autocomplete>
      </b-field>
    </div>
    <div class="column is-2">
      <b-field
        label="出品番号"
        expanded
        :type="listErrType.errLotNo"
        :message="listMsgValidation.msgLotNo"
      >
        <b-input v-model="item.lotNo" @input="validationInput"></b-input>
      </b-field>
    </div>
  </div>
</template>
<style>
.borderRed input {
  border: solid red 1px;
}
</style>
<script>
const regexFormatNumber = /^[0-9]+$/;
import moment from 'moment';
export default {
  props: ['item', 'auctions', 'isValidate', 'dataJCPackage'],
  data: () => ({
    biddingDate: {},
    auctionSiteList: [],
    auctionVendorInput: '',
    todate: {},
    isSave: true,
    listMsgValidation: {
      msgLotNo: '',
    },
    listErrType: {
      errLotNo: '',
    },
  }),
  created() {
    this.init();
  },
  watch: {
    item: function () {
      this.init();
    },
    'item.yardTransportId': function () {
      this.auctionVendorInput = this.item.yardTransportId;
    },
    auctionVendorInput: function () {
      this.item.transportFromId = this.auctionVendorInput;
    },
  },
  computed: {
    filteredAuctionSiteList() {
      return this.auctions.filter(
        (option) =>
          option.E_AuctionAreaSatellite.value
            .toUpperCase()
            .indexOf(this.auctionVendorInput.toUpperCase()) >= 0
      );
    },
  },
  methods: {
    init() {
      this.todate = moment().toDate();
      this.auctionVendorInput = this.item.transportFromId;
      //START QuocNV 20230529 add new from yard place to yard when transport 2++
      this.item.fromYardPlace = this.item.yardIdTemp;
      //END QuocNV 20230529 add new from yard place to yard when transport 2++
      if (this.item.orderDate != '') {
        this.biddingDate = moment().toDate();
      }
      const auction = this.auctions.find(
        (v) => v.AA_ID.value == this.item.transportFromId
      );
      if (auction && this.item.status == 0) {
        this.setAuctionVendor(auction);
      }
    },
    changeBiddingDate() {
      this.handleBlurIsValidate();
      this.item.orderDate = this.biddingDate
        ? moment(this.biddingDate).format('YYYY-MM-DD')
        : '';
    },
    setAuctionVendor(auction) {
      this.item.transportFromId = auction ? auction.AA_ID.value : '';
      this.item.transportFromName = auction
        ? auction.AuctionAreaSatellite.value
        : '';
      //START QuocNV 20230529 add new from yard place to yard when transport 2++
      this.item.fromYardPlace = null;
      //END QuocNV 20230529 add new from yard place to yard when transport 2++
      this.$emit('auctionVendorChanged', auction);
    },
    handleBlurIsValidate() {
      this.$emit('changeIsvalidate', false);
      if (this.dataJCPackage) {
        if (
          moment(
            this.dataJCPackage.order_date.replaceAll('/', '-')
          ).isSameOrAfter(this.item.orderDate)
        ) {
          this.$emit('changeIsvalidate', false);
        } else {
          this.$emit('changeIsvalidate', true);
        }
      }
    },
    validationInput() {
      const lotnoStr = this.item.lotNo ? this.item.lotNo : ''
      if (lotnoStr.length <= 10) {
        this.listErrType.errLotNo = '';
        this.listMsgValidation.msgLotNo = '';
        this.isSave = true;
      } else {
        this.listErrType.errLotNo = 'is-danger';
        this.listMsgValidation.msgLotNo =
          '出品番号は10桁以内の英数字で入力してください。前ゼロは削除されます。';
        this.isSave = false;
      }
      // if (regexFormatNumber.test(this.item.lotNo)) {
      //   this.listErrType.errLotNo = '';
      //   this.listMsgValidation.msgLotNo = '';
      //   this.isSave = true;
      // } else {
      //   this.listErrType.errLotNo = 'is-danger';
      //   this.listMsgValidation.msgLotNo =
      //     '出品番号に誤りがあります。すべて数字で入力してください。前ゼロは削除されます。';
      //   this.isSave = false;
      // }
      this.$emit('responeValidateItemAuction', this.listMsgValidation);
    },
  },
};
</script>
